<template>
  <div class="page-container">
    <el-card>
      <!-- 时间筛选 -->
      <app-date-picker
        style="padding: 10px 0;"
        :data="date"
        type="daterange"
        @change="changeDate"
      />
      <app-filter
        :filter-list="table_filter"
        @search="searchTable"
      />
      <el-button
        style="margin-top: 10px"
        type="success"
        size="mini"
        @click="exportExcel"
      >导出</el-button>
    </el-card>
    <el-card class="mt-20">
      <app-table
        ref="my-table"
        :table-key="table_key"
        :tablep="material_list_params"
        :table-on="table_on"
        :get-data="getMaterialList"
      />
    </el-card>
    <!-- 素材编辑弹框 -->
    <material-edit
      v-if="edit_material.is_show"
      :id="edit_material.data.id"
      :type="edit_material.data.material_type"
      :is-open="edit_material.is_show"
      @cancel="edit_material.is_show = false"
      @confirm="editMaterialConfirm"
    />
    <!-- 素材添加更新素材标弹窗 -->
    <el-dialog v-bind="material_labels_config.props" :visible.sync="material_labels_config.is_show">
      <div v-loading="material_labels_config.is_loading" class="w-full material-labels-wrapper">
        <el-card v-if="material_labels_config.is_show" class="w-full material-card" shadow="never">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-input v-model="material_labels_config.keyword" :disabled="!is_exist_raw_data" size="mini" placeholder="请输入标签名称进行搜索，多组名称以、分隔" @input="throttleKeywordChange" />
              <el-card shadow="never" class="mt-20 labels-wrapper">
                <div slot="header" class="flex justify-between items-center">
                  <span class="font-16">{{ labels_proxy.label }}</span>
                  <el-checkbox v-model="material_labels_config.is_check_all" :indeterminate="material_labels_config.is_indeterminate" :disabled="!labels_proxy.options?.length" @change="onLabelCheckAllsChange">全选</el-checkbox>
                </div>
                <div class="checkbox-wrapper">
                  <el-scrollbar class="w-full h-full" wrap-style="overflow-x:hidden;">
                    <el-checkbox-group v-model="material_labels_config.form_config.material_label_ids.value" class="w-full h-full checkbox-group-wrapper overflow-x-hidden" :max="material_labels_config.limit" @change="onMaterialLabelIdChange">
                      <el-checkbox v-for="material_label_id in labels_proxy.options" :key="material_label_id.value" :label="material_label_id.value">
                        <span class="checkbox-label inline-block truncate" :title="material_label_id.label">{{ material_label_id.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                    <el-empty v-show="!labels_proxy.options?.length" description="暂无标签" />
                  </el-scrollbar>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="checked-labels-wrapper" shadow="never">
                <div slot="header" class="flex justify-between items-center">
                  <span class="font-16">已选{{ checked_labels_proxy.length }}</span>
                  <el-button class="clear-all-btn" type="text" :disabled="!checked_labels_proxy.length" @click="onClearAllTags">清空全部</el-button>
                </div>
                <div class="tags-wrapper">
                  <el-scrollbar class="h-full" wrap-style="overflow-x:hidden;">
                    <el-tag v-for="(material_label, material_label_index) in checked_labels_proxy" :key="material_label.value" :disable-transitions="true" :class="{ 'w-full relative text-center truncate cursor-pointer': true, 'mb-10': material_label_index !== checked_labels_proxy.length - 1 }" :title="material_label.label" size="medium" closable @close="onRemoveMaterialLabel(material_label.value)">{{ material_label.label }}</el-tag>
                    <el-empty v-show="!checked_labels_proxy.length" description="暂未选择" />
                  </el-scrollbar>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <div class="w-full text-right mt-20">
            <el-button size="mini" @click="material_labels_config.is_show = false">取 消</el-button>
            <el-button size="mini" :disabled="!is_exist_raw_data" type="primary" :loading="material_labels_config.is_submit_loading" @click="onUpdateMaterialLabels">确 定</el-button>
          </div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
// 素材列表接口
import MaterialResource from '@/api/material/index';
const materialResource = new MaterialResource();
// 素材规格列表接口
import MaterialFormatResource from '@/api/material/format';
const materialFormatResource = new MaterialFormatResource();

// 获取游戏列表接口
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

// 获取用户列表接口
import UserResource from '@/api/user';
const userResource = new UserResource();

import { downloadFile } from '@/utils/download.js';
import { getMaterialLabelSelectorApi } from '@/api/material/label';
import { clone, uniqueArr, throttle, getArrayIntersection } from '@/utils';
import { isObject } from '@/utils/is';

export default {
  components: {
    'material-preview': () => import('../components/material-preview'),
    'app-table': () => import('@/components/app-table'),
    'app-date-picker': () => import('@/components/app-date-picker'),
    'app-filter': () => import('@/components/app-filter'),
    'material-edit': () => import('./components/material-edit'),
    'select-edit': () => import('./components/select-edit'),
  },
  data() {
    return {
      /** 搜索素材标签节流版 */
      throttleKeywordChange: throttle(this.onLabelKeywordChange, 500),
      /** 标签弹窗配置 */
      material_labels_config: {
        /** 正在加载 */
        is_loading: false,
        /** 正在请求提交 */
        is_submit_loading: false,
        /** 是否显示弹窗 */
        is_show: false,
        /** 本地素材ID */
        material_id: null,
        /** 弹窗props */
        props: {
          title: '标签',
          width: '800px',
        },
        /** 关键词 */
        keyword: '',
        /** 允许选择最大素材标签个数 */
        limit: 10,
        /** 是否全选 */
        is_check_all: false,
        /** 是否不确定全选 */
        is_indeterminate: true,
        /** 表单配置 */
        form_config: {
          /** 标签 */
          material_label_ids: {
            /** 已经选中的标签 */
            value: [],
            /** 待选数据 */
            data: [],
            /** 原始待选数据 */
            raw_data: [],
          },
        },
      },
      someAttr: 'hidden',
      date: [new Date(), new Date()],
      // 素材列表参数
      material_list_params: {
        start_date: moment(new Date()).format('YYYY-MM-DD'),
        end_date: moment(new Date()).format('YYYY-MM-DD'),
        sort_prop: 'updated_at',
        sort_order: 'DESC',
        page: 1,
        limit: 10,
      },
      // 编辑素材对象
      edit_material: {
        is_show: false,
        data: {},
      },
      // 表格事件
      table_on: {
        'sort-change': ({ column, prop, order }) => {
          this.material_list_params['sort_prop'] = prop;

          if (order === 'descending') {
            this.material_list_params['sort_order'] = 'DESC';
          } else if (order === 'ascending') {
            this.material_list_params['sort_order'] = 'ASC';
          } else {
            delete this.material_list_params.sort_order;
            delete this.material_list_params.sort_prop;
          }
          this.$refs['my-table'].seekTable();
        },
      },
      // 筛选条件
      table_filter: require('./module/table-filter.js')(this),
      // 表格头部
      table_key: require('./module/table-key.js')(this),
    };
  },
  computed: {
    /** 已选标签 */
    checked_labels_proxy() {
      const { material_label_ids } = this.material_labels_config.form_config;
      const { raw_data } = material_label_ids;
      return raw_data.length ? raw_data[0].options.filter(({ value }) => material_label_ids.value.includes(value)) : [];
    },
    /** 待选标签 */
    labels_proxy() {
      const { data } = this.material_labels_config.form_config.material_label_ids;
      return data.length ? data[0] : {};
    },
    /** 是否存在待选标签 */
    is_exist_raw_data() {
      const { raw_data } = this.material_labels_config.form_config.material_label_ids;
      return !!raw_data.length;
    },
  },
  created() {
    this.addTableFilterEvent();
  },
  mounted() {
    this.getGameList({ refresh: 1, is_parent: 0, is_order_by_material_count: 1 }).then((res) => {
      for (let i = 0; i < res.list.length; i++) {
        res.list[i]['disabled'] = true;
      }
      this.table_filter.game_ids.props.options = res.list;
    });

    this.getUserListData({ page: 1, limit: -1 }).then((res) => {
      this.table_filter.demand_sider_id.options = res.data.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });

      this.table_filter.author_id.options = this.table_filter.demand_sider_id.options;
    });
    this.setMaterialLabelSelectorData();
  },
  methods: {
    /**
     * 添加表格过滤项监听事件
     * @returns {void}
     */
    addTableFilterEvent() {
      const { search_type, name, local_material_ids } = this.table_filter;
      search_type.on = {
        change: () => {
          const is_name = search_type.value === 'name';
          name.hidden = !is_name;
          local_material_ids.hidden = is_name;
        },
      };
    },
    // 获取素材列表
    getMaterialList: function(params) {
      return new Promise((resolve, reject) => {
        materialResource
          .getMaterialListApi(params)
          .then((response) => {
            if (response.list) {
              response.list.map((item) => {
                item.name = {
                  is_edit: false,
                  value: item.name,
                };

                item.note = {
                  is_edit: false,
                  value: item.note,
                };

                item.demand_sider = {
                  is_edit: false,
                  value: item.demand_sider?.id,
                };
                return item;
              });
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取素材规格列表
    getMaterialFormatList: function(params) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .getMaterialFormatListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取游戏列表
    getGameList: function(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getGameListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 下载素材
    downloadMaterial: function(params) {
      return new Promise((resolve, reject) => {
        materialResource
          .downloadMaterialApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 删除素材
    removeMaterial: function(params) {
      return new Promise((resolve, reject) => {
        materialResource
          .removeMaterialApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     *  更新素材标签接口
     *  @param params 接口参数
     *  @param id 当前选中行的id
    */
    updateTag: function(params, id) {
      return new Promise((resolve, reject) => {
        materialResource
          .updateTagApi(params, id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     *  更新素材备注
     *  @param params 接口参数
     *  @param id 当前选中行的id
    */
    updateNote: function(params, id) {
      return new Promise((resolve, reject) => {
        materialResource
          .updateNoteApi(params, id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     *  更新素材名称
     *  @param params 接口参数
     *  @param id 当前选中行的id
    */
    updateName: function(params, id) {
      return new Promise((resolve, reject) => {
        materialResource
          .updateNameApi(params, id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
     *  更新素材需求方
     *  @param params 接口参数
     *  @param id 当前选中行的id
    */
    updateDemandSider: function(params, id) {
      return new Promise((resolve, reject) => {
        materialResource
          .updateDemandSiderApi(params, id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 素材类型选择事件
    onMaterialTypeChange: function(val) {
      this.table_filter.material_format_id.props.loading = true;
      this.table_filter.material_format_id.value = null;
      this.table_filter.material_format_id.options = [];
      this.getMaterialFormatList({ type: val }).then((res) => {
        this.table_filter.material_format_id.props.loading = false;
        this.table_filter.material_type.props.loading = false;
        this.table_filter.material_format_id.options = res.list.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      });
    },
    // 获取用户列表
    getUserListData: function(params) {
      return new Promise((resolve, reject) => {
        userResource
          .getUserList(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 下载ZIP
    downloadZip: function(res, file_name) {
      const blob = new Blob([res], { type: 'application/zip' });
      if ('download' in document.createElement('a')){
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = `${file_name}.zip`;
        link.href = url;
        link.click();
        // 释放内存
        URL.revokeObjectURL(url);
      } else {
        // ie10下载
        navigator.msSaveOrOpenBlob(blob);
      }
    },

    /**
     * 复制内容到剪切板
     * @param {string} content 需要复制的内容
     */
    copyToClip(content){
      var input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('value', content);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success('链接已复制好，可贴粘');
      }
      document.body.removeChild(input);
    },

    /** 编辑素材确定回调 */
    editMaterialConfirm() {
      this.edit_material.is_show = false;
      this.$refs['my-table'].refer();
    },
    /** 导出表格 */
    exportExcel: function() {
      const export_params = JSON.parse(JSON.stringify(this.material_list_params));
      export_params['is_export'] = 1;
      materialResource.getMaterialListApi(export_params).then((res) => {
        const { start_date, end_date } = export_params;
        const file_name = `${start_date}_${end_date}.csv`;
        downloadFile(res, file_name);
      });
    },
    // 搜索表格
    searchTable: function(obj) {
      this.material_list_params = Object.assign(this.material_list_params, obj);

      if (obj?.game_ids) {
        this.material_list_params.game_ids = [obj.game_ids];
      }

      if (isObject(obj)) {
        !obj.name && delete this.material_list_params.name;
        obj.local_material_ids ? (this.material_list_params.local_material_ids = [obj.local_material_ids]) : delete this.material_list_params.local_material_ids;
      }

      this.$refs['my-table'].seekTable();
    },

    // 改变时间
    changeDate(data){
      if (data?.length === 2) {
        this.material_list_params.start_date = data[0];
        this.material_list_params.end_date = data[1];
      } else {
        this.material_list_params.start_date = undefined;
        this.material_list_params.end_date = undefined;
      }

      this.searchTable();
    },

    /**
     * 渲染修改dom
     * @param row 当前行数据
     * @param cell_value 当前行value值
     * @param func 更新接口函数
     * @param type 当前更改的类别
     */
    randerEditDom(row, cell_value, func, type){
      const s = this;
      const h = s.$createElement;
      const ele = h('div',
        null, [
          type === 'demand_sider_id'
            ? h('select-edit', {
              props: {
                value: cell_value.value,
                list: this.table_filter.demand_sider_id.options,
                disabled: !cell_value.is_edit,
              },
              on: {
                change: (val) => {
                  cell_value.value = val;
                },
              },
            })
            : h('el-input', {
              style: {
                width: '100px',
              },
              props: {
                value: cell_value.value,
                size: 'mini',
                disabled: !cell_value.is_edit,
              },
              on: {
                input: function(val) {
                  cell_value.value = val;
                },
              },
            }, cell_value.value),
          h('el-button',
            {
              props: {
                icon: cell_value.is_edit ? 'el-icon-check' : 'el-icon-edit',
                type: cell_value.is_edit ? 'success' : 'primary',
                size: 'mini',
              },
              on: {
                click: () => {
                  if (cell_value.is_edit) {
                    let params = {};

                    switch (type) {
                      case 'note':
                        params = { note: cell_value.value };
                        break;
                      case 'name':
                        params = { name: cell_value.value };
                        break;
                      case 'demand_sider_id':
                        params = { demand_sider_id: cell_value.value };
                        break;
                    }

                    func(params, row.id).then((res) => {
                      s.$message({
                        message: res.message,
                        type: 'success',
                      });
                      s.$refs['my-table'].refer();
                    });
                  }
                  cell_value.is_edit = !cell_value.is_edit;
                },
              },
            }, ''),
        ]);
      return ele;
    },
    /** 素材标签选择器 */
    getMaterialLabelSelector(params) {
      return new Promise((resolve, reject) => {
        getMaterialLabelSelectorApi(params).then((res) => {
          const options = (res?.list || []).map(({ game_name, material_labels }) => {
            return {
              label: game_name,
              options: material_labels.map(({ id: value, label_name: label }) => ({ label, value })),
            };
          });
          resolve(options);
        }).catch(reject);
      });
    },
    /** 设置素材标签选择器数据 */
    setMaterialLabelSelectorData() {
      this.getMaterialLabelSelector().then((response) => {
        this.table_filter.material_label_ids.options = response;
      });
    },
    /** 重置素材标签数据 */
    resetMaterialLabelIds() {
      this.material_labels_config.form_config.material_label_ids.value.splice(0);
      this.material_labels_config.form_config.material_label_ids.data.splice(0);
      this.material_labels_config.form_config.material_label_ids.raw_data.splice(0);
    },
    /**
     * 查看素材拥有的素材标签
     * @param {number} id 本地素材ID
     * @param {Object} game 游戏信息
     */
    async onViewLocalMaterialLabels({ id: material_id, game = {}}) {
      try {
        this.resetMaterialLabelIds();
        Object.assign(this.material_labels_config, { material_id, is_show: true, is_loading: true, is_check_all: false, is_indeterminate: true, keyword: '' });
        const { list: material_labels = [] } = await materialResource.getLocalMaterialLabelsApi(material_id) || {};
        const { material_label_ids } = this.material_labels_config.form_config;
        material_label_ids.value = material_labels.map(({ id }) => id);
        const result = await this.getMaterialLabelSelector({ game_id: game.parent_id });
        material_label_ids.raw_data = result;
        material_label_ids.data = clone(result);
        this.onMaterialLabelIdChange(material_label_ids.value);
      } catch {
        this.material_labels_config.material_id = null;
        this.resetMaterialLabelIds();
      } finally {
        Object.assign(this.material_labels_config, { is_loading: false });
      }
    },
    /** 素材添加更新素材标签 */
    async onUpdateMaterialLabels() {
      try {
        this.material_labels_config.is_submit_loading = true;
        const { value: material_label_ids } = this.material_labels_config.form_config.material_label_ids;
        if (!material_label_ids.length) {
          this.$message.warning('请选择标签！');
          return;
        }
        const { material_id } = this.material_labels_config;
        await materialResource.addLocalMaterialLabelsApi(material_id, { material_label_ids });
        this.$message.success('设置标签成功！');
        this.material_labels_config.is_show = false;
        this.$refs['my-table'].refer();
      } finally {
        this.material_labels_config.is_submit_loading = false;
      }
    },
    /**
     * 删除标签
     * @param {number} material_label_id 素材标签ID
     */
    onRemoveMaterialLabel(material_label_id) {
      const { material_label_ids } = this.material_labels_config.form_config;
      const index = material_label_ids.value.indexOf(material_label_id);
      index !== -1 && material_label_ids.value.splice(index, 1);
      this.onMaterialLabelIdChange(material_label_ids.value);
    },
    /** 搜索标签 */
    onLabelKeywordChange(val) {
      const { raw_data, value } = this.material_labels_config.form_config.material_label_ids;
      let new_options = [];
      if (val.includes('、')) {
        const values = val.split('、');
        new_options = raw_data[0].options.filter(({ label }) => values.some(val => val && label.includes(val)));
      } else {
        new_options = raw_data[0].options.filter(({ label }) => (label || '').indexOf(val) > -1);
      }
      this.material_labels_config.form_config.material_label_ids.data[0].options = clone(new_options);
      this.onMaterialLabelIdChange(value);
    },
    /** 清空已选标签 */
    onClearAllTags() {
      const { material_label_ids } = this.material_labels_config.form_config;
      material_label_ids.value.splice(0);
      this.onMaterialLabelIdChange(material_label_ids.value);
    },
    /**
     * 全选素材标签
     * @param {boolean} val 是否全选
     */
    onLabelCheckAllsChange(val) {
      const check_ids = this.material_labels_config.form_config.material_label_ids.value;
      const ids = this.labels_proxy.options.map(({ value }) => value);
      const merge_ids = clone(uniqueArr([...check_ids, ...ids]));
      const limit = this.material_labels_config.limit;
      if (!val) {
        ids.forEach(id => this.onRemoveMaterialLabel(id));
        return;
      }
      if (merge_ids.length <= limit) {
        this.material_labels_config.form_config.material_label_ids.value = merge_ids;
        this.onMaterialLabelIdChange(merge_ids);
      } else {
        this.$message.warning(`素材最多${limit}个标签`);
        this.$nextTick(() => this.onMaterialLabelIdChange(check_ids));
      }
    },
    /**
     * 监听素材标签选中
     * @param {number[]} value 当前已选中的素材标签ids
     */
    onMaterialLabelIdChange(value) {
      const { options } = this.labels_proxy;
      const material_label_ids = options.map(({ value }) => value);
      const checked_count = getArrayIntersection(material_label_ids, value).length;
      this.material_labels_config.is_check_all = options.length ? (options.every(opt => value.includes(opt.value))) : false;
      this.material_labels_config.is_indeterminate = checked_count > 0 && checked_count < options.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.material-labels-wrapper {
  .material-card {
    min-height: 500px;
    .checkbox-wrapper {
      height: 321px;
      .checkbox-group-wrapper {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-row-gap: 10px;
        .checkbox-label {
          max-width: 100px;
          vertical-align: middle;
        }
      }
    }
    .checked-labels-wrapper {
      .tags-wrapper {
        height: 370px;
        /deep/ .el-tag__close {
          position: absolute;
          right: 5px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .clear-all-btn {
    padding: 0;
  }
}
</style>
